const mediaItems = [
  {
    title: '《长安十二时辰》第二季·风云再起',
    desc: '古装悬疑巨制回归，易烊千玺领衔主演，盛唐危机一触即发',
    duration: '全48集',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20cityscape%20at%20twilight%20with%20warm%20lantern%20lights%20and%20dramatic%20sky%2C%20epic%20scale%2C%20atmospheric%20fog%2C%20no%20text%2C%20film%20quality&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '《向往的生活》第八季·海岛篇',
    desc: '黄磊何炅带队，全新海岛田园生活，治愈系慢综艺回归',
    duration: '更新至12期',
    img: 'https://readdy.ai/api/search-image?query=Peaceful%20tropical%20beach%20scene%20with%20warm%20golden%20hour%20sunlight%2C%20gentle%20waves%2C%20minimalist%20natural%20composition%2C%20serene%20atmosphere%2C%20no%20text%2C%20cinematic%20quality&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '《咒术回战》第二季·涩谷事变',
    desc: '现象级热血日漫，茄子视频同步更新，激战画面再升级',
    duration: '全23集',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20energy%20burst%20with%20warm%20orange%20and%20deep%20red%20gradients%2C%20fluid%20motion%20lines%2C%20intense%20atmosphere%2C%20no%20text%2C%20anime%20aesthetic%20quality&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '《奥本海默》高清完整版',
    desc: '诺兰史诗级传记大片，基里安·墨菲神级演技，IMAX画质体验',
    duration: '180分钟',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20abstract%20with%20intense%20warm%20light%20burst%20against%20dark%20background%2C%20particles%20and%20atmospheric%20smoke%2C%20powerful%20composition%2C%20no%20text%2C%20film%20poster%20quality&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">精彩视频</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">热播影视内容精选，点击即可观看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer transition-all hover:bg-background-200"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200 relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 left-3 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-1 rounded">
                  {item.duration}
                </span>
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-background-50 text-xl"></i>
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}